import React, { Component } from 'react';
import styles from "./styles.module.css";
import Modal from '@material-ui/core/Modal';
import Form from './form/'

class ModalForm extends Component {
    render() {
        const {open} = this.props;
        return (
            <div>
                <Modal
                    open={open}
                    onClose={this.props.handleClose}
                >
                    <div className={styles.modal} >
                        <Form closeModal={this.props.handleClose}></Form>
                    </div> 
                </Modal>
            </div>
        );
    }
}

export default ModalForm;